import { render, staticRenderFns } from "./chartComponent.vue?vue&type=template&id=5cb81989&scoped=true"
import script from "./chartComponent.vue?vue&type=script&lang=js"
export * from "./chartComponent.vue?vue&type=script&lang=js"
import style0 from "./chartComponent.vue?vue&type=style&index=0&id=5cb81989&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb81989",
  null
  
)

export default component.exports